import { v4 as uuid } from "uuid"

export const UNIT_ENTITY = "unit"

export interface Unit {
  id: string
  name: string
  description: string
  size: number | null
  JobIds: string[]
  attributes?: string[]
}

export const createEmptyUnit = (overrides?: Partial<Unit>): Unit => {
  const defaultUnit: Unit = {
    id: uuid(),
    name: "",
    description: "",
    size: null,
    JobIds: []
  }

  return {
    ...defaultUnit,
    ...overrides
  }
}
